import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const imageLicenses = {
  col1: [
    "\u00a9 vege - Fotolia.com (ID: 61003743)",
    "\u00a9 vege - Fotolia.com (ID: 68888128)",
    "\u00a9 kraftwerk - Fotolia.com (ID: 43816459)",
    "\u00a9 stnazkul - Fotolia.com (ID: 70043857)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71558445)",
    "\u00a9 ty - Fotolia.com (ID: 69876126)",
    "\u00a9 stnazkul - Fotolia.com (ID: 74318288)",
  ],
  col2: [
    "\u00a9 everythingpossible - Fotolia.com (ID: 75176784)",
    "\u00a9 PRCreativeTeam - Fotolia.com (ID: 32926218)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 60594952)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555591)",
    "\u00a9 kalafoto - Fotolia.com (ID: 76548158)",
    "\u00a9 Sergey Nivens - Fotolia.com (ID: 75074205)",
    "\u00a9 Minerva Studio - Fotolia.com (ID: 44001165)",
  ],
  col3: [
    "\u00a9 ty - Fotolia.com (ID: 77611976)",
    "\u00a9 Brian Jackson - Fotolia.com (ID: 71272430)",
    "\u00a9 vege - Fotolia.com (ID: 68009271)",
    "\u00a9 vege - Fotolia.com (ID: 69466546)",
    "\u00a9 lenetsnikolai - Fotolia.com (ID: 79605839)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 67233512)",
    "\u00a9 vege - Fotolia.com (ID: 68666829)",
  ],
  col4: [
    "\u00a9 vege - Fotolia.com (ID: 64727666)",
    "\u00a9 vege - Fotolia.com (ID: 68576622)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 53066900)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 68132249)",
    "\u00a9 vege - Fotolia.com (ID: 70085709)",
    "\u00a9 everythingpossible - Fotolia.com (ID: 71555523)",
    "\u00a9 bloomua - Fotolia.com (ID: 44334833)",
    "\u00a9 vege - Fotolia.com (ID: 69992403)",
  ],
};

export default function ImprintPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PageHead
        title="Impressum | NetBasis International"
        description="Rechtliche Anbieterkennzeichnung, Haftungsausschluss und lizenzierte Bildnachweise von NetBasis International gemäß den gesetzlichen Vorgaben."
        ogUrl="https://net-basis.net/de/impressum"
      />
      <Header />
      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero Image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src="https://net-basis.net/Bilder/netbasis-legal-notice-privacy-policy.webp"
                alt="Impressum"
                title="Impressum"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row gap-10 md:gap-12 lg:gap-16">
              {/* Left Column - 1/3 */}
              <div className="w-full md:w-1/3">
                <section>
                  <h1 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Impressum
                  </h1>

                  <div className="space-y-6">
                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Angaben gemäß § 5 DDG
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Christof Günther{'\n'}NetBasis International{'\n'}Heinrichstraße 45{'\n'}40239 Düsseldorf
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Kontakt
                      </h2>
                      <div className="font-body text-sm md:text-base text-foreground-950 leading-relaxed space-y-1">
                        <p>
                          <span className="text-foreground-950">Telefon:</span>{" "}
                          <a
                            href="tel:+4921154419380"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            +49 (0) 211 / 544 193 80
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">E-Mail:</span>{" "}
                          <a
                            href="mailto:kontakt@net-basis.com"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            kontakt@net-basis.com
                          </a>
                        </p>
                        <p>
                          <span className="text-foreground-950">Internet:</span>{" "}
                          <a
                            href="https://net-basis.net/de"
                            className="text-foreground-950 hover:underline transition-colors cursor-pointer"
                          >
                            net-basis.net
                          </a>
                        </p>
                      </div>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Umsatzsteuer-ID
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:{'\n'}DE 258 486 954
                      </p>
                    </div>

                    <div>
                      <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Berufshaftpflichtversicherung
                      </h2>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed whitespace-pre-line">
                        Name und Sitz der Gesellschaft:{'\n'}Hiscox AG in Vollmacht für Hiscox Insurance Company Ltd.{'\n'}Niederlassung für Deutschland, Arnulfstraße 31, 80636 München{'\n'}Geltungsraum der Versicherung: Weltweit
                      </p>
                    </div>
                  </div>
                </section>
              </div>

              {/* Right Column - 2/3 */}
              <div className="w-full md:w-2/3">
                <section>
                  <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
                    Haftungsausschluss
                  </h2>

                  <div className="space-y-6">
                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Haftung für Inhalte
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Die Inhalte unserer Internetpräsenz wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Haftung für Links
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Urheberrecht
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Die durch uns erstellten bzw. verwendeten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen unserer Zustimmung. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf unserer Seite nicht von uns erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                        Bildnachweise
                      </h3>
                      <p className="font-body text-sm md:text-base text-foreground-950 leading-relaxed">
                        Die auf dieser Webseite verwendeten Fotolia-/Adobe-Stock-Bilder wurden ordnungsgemäß lizenziert. Die detaillierten Urhebernachweise entnehmen Sie bitte der folgenden Übersicht:
                      </p>
                      <div className="mt-4 w-full">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1">
                          {imageLicenses.col1.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col2.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col3.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                          {imageLicenses.col4.map((item) => (
                            <p key={item} className="font-body text-[10px] leading-tight text-foreground-600">
                              {item}
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}